import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  client: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.client',
    defaultMessage: 'Client',
  },
  order: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.order',
    defaultMessage: 'Commande',
  },
  file: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.file',
    defaultMessage: 'Dossier',
  },
  firstName: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.lastName',
    defaultMessage: 'Last Name',
  },
  reasonComment: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.reasonComment',
    defaultMessage: 'Commentaire',
  },
  orderReference: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.orderReference',
    defaultMessage: 'Numéro de commande',
  },
  sellerName: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.sellerName',
    defaultMessage: 'Seller Name',
  },
  purchaseDate: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.purchaseDate',
    defaultMessage: "Date d'achat",
  },
  serialNumber: {
    id: 'view.FileInfo.FileTabs.FileSummaryNewUi.serialNumber',
    defaultMessage: 'Serial Number',
  },
  fileCreatedDate: {
    id: 'view.card.claim.declarationDate',
    defaultMessage: 'Date de la demande',
  },
  holder: {
    id: 'view.file.tabs.summary.holder.title',
    defaultMessage: 'Détenteur',
  },
  actor: {
    id: 'view.filterAside.actorId',
    defaultMessage: 'Acteur',
  },
  siteActor: {
    id: 'view.file.tabs.summary.siteActor',
    defaultMessage: 'Site',
  },
  storeActor: {
    id: 'view.file.tabs.summary.storeActor',
    defaultMessage: 'Magasin',
  },
  issueName: {
    id: 'components.myaccount.common.issue',
    defaultMessage: 'Motif',
  },
  reasonName: {
    id: 'view.card.claim.reasonName',
    defaultMessage: 'Raison',
  },
  solutionName: {
    id: 'components.myaccount.common.solution',
    defaultMessage: 'Solution',
  },
  fileOwner: {
    id: 'view.file.tabs.summary.fileOwner',
    defaultMessage: 'Responsable du dossier',
  },
  depositStore: {
    id: 'view.folders.tabs.claim.depositStore',
    defaultMessage: 'Magasin de dépôt',
  },
  warrantyTypeName: {
    id: 'view.card.claim.warrantyTypeName',
    defaultMessage: 'Garantie',
  },
  sku: {
    id: 'poc.dossierFileSummary.sku',
    defaultMessage: 'SKU',
  },
  ean: {
    id: 'poc.dossierFileSummary.ean',
    defaultMessage: 'EAN',
  },
  description: {
    id: 'poc.dossierFileSummary.description',
    defaultMessage: 'Description',
  },
  rmaType: {
    id: 'view.file.tabs.summary.rmaType',
    defaultMessage: 'Type RMA',
  },
  None: {
    id: 'view.file.tabs.summary.rmaType.None',
    defaultMessage: 'None',
  },
  Auto: {
    id: 'view.file.tabs.summary.rmaType.Auto',
    defaultMessage: 'Auto',
  },
  Manual: {
    id: 'view.file.tabs.summary.rmaType.Manual',
    defaultMessage: 'Manual',
  },
  email: {
    id: 'view.card.client.email',
    defaultMessage: 'Email',
  },
  phone: {
    id: 'authenticator.onboarding.form.phoneLabel',
    defaultMessage: 'Phone',
  },
  marketPlace: {
    id: 'view.card.client.marketPlace',
    defaultMessage: 'Market place',
  },
  PurchaseStore: {
    id: 'ActorTypes.PurchaseStore',
    defaultMessage: "Magasin d'achat",
  },
  showAllOrder: {
    id: 'poc.dossierFileSummary.showAllOrder',
    defaultMessage: 'Tout afficher',
  },
  orderDocumentType: {
    id: 'view.card.client.orderDocumentType',
    defaultMessage: 'Order document type',
  },
  orderDeliveryMethod: {
    id: 'view.card.client.orderDeliveryMethod',
    defaultMessage: 'Order delivery method',
  },
});
